import React from "react";
import Link from "gatsby-link";
import { rhythm } from "../../utils/typography";

import "./tags.css";

// eslint-disable-next-line react/prop-types
export default function Tags({ list = [] }) {
  return (
    <ul className="tags">
      {list.map(tag => <li key={tag}>
          <Link to={`/tags/${tag}`} style={{ fontSize: rhythm(2.25 / 5) }}>
            {tag}
          </Link>
        </li>)}
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/components/Tags/index.jsx